import axios from "axios";
const BASE_URL = "https://cpsidvp5a9.eu-west-1.awsapprunner.com";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
